module.exports = __webpack_public_path__ + "static/fonts/Arita-buriSB.178e72a.eot";